import { Box, Typography } from '@mui/material'
import { observer } from 'mobx-react-lite'
import React, { useEffect } from 'react'
import CustomAccordion from '../../../../../components/customElements/RequestDataAccordions/utils/CustomAccordion'
import { openModalFn } from '../../../../../utils/controllers/ModalController'

const ApplicationServicingAccordion = ({ serviceStore }) => {
  const { currentServiceData, getServicePhotosFunc, servicePhotos } =
    serviceStore

  useEffect(() => {
    getServicePhotosFunc(currentServiceData.id, [
      'Clarification',
      'WarrantyServiceRequired',
      'MaintenanceImpossible',
      'ImprovementRequired',
      'MaintenanceCompleted',
      'DiagnosticCompleted',
    ])
  }, [])

  const pictures = Object.values(servicePhotos).filter((value) => value.isExist)

  return (
    <>
      {!!pictures?.length && (
        <CustomAccordion
          summary={'Информация об обслуживании'}
          defaultOpenState={true}
          preventHandleOpen={false}
        >
          {pictures.map((collection) => (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '12px',
                marginTop: '12px',
                paddingLeft: '12px',
              }}
              key={collection.name}
            >
              <Box>
                <Typography
                  variant={'body2'}
                  color={'grey.500'}
                  sx={{
                    fontSize: '15px',
                    marginY: '4px',
                    lineHeight: 1,
                    mb: '8px',
                  }}
                >
                  {collection.name}
                </Typography>
                <Box sx={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                  {collection.urls.map((url, i) => {
                    return (
                      <img
                        style={{
                          width: '64px',
                          height: '64px',
                          borderRadius: '8px',
                          border: '1px solid gray',
                          cursor: 'pointer',
                        }}
                        src={url}
                        onClick={() => {
                          openModalFn['photo-gallery']({
                            collection: collection.list,
                            initialIndex: i,
                            name: collection.name,
                          })
                        }}
                        key={url}
                      />
                    )
                  })}
                </Box>
              </Box>
            </Box>
          ))}
        </CustomAccordion>
      )}
    </>
  )
}

export default observer(ApplicationServicingAccordion)
